import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { Auth } from '@/app/core/services/auth';

export const privateGuard: CanActivateChildFn = (_childRoute, state) => {
  const router = inject(Router);
  const auth = inject(Auth);

  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
  }

  return true;
};
